import { ref } from 'vue';
import { defineStore } from 'pinia';

interface AiSettings {
    aiEnabled: boolean;
}

export const useAiSettingsStore = defineStore('aiSettings', () =>
{
    const aiSettings = ref<AiSettings>({
        aiEnabled: false
    });

    return { aiSettings };
});
